import React from "react";
import { AonLabel, LABEL_TYPE } from "../AonLabel";
import { AonPopover } from "../AonPopover";
var AonTooltip = function (_a) {
    var position = _a.position, text = _a.text, width = _a.width, children = _a.children, darkMode = _a.darkMode, isFullWidth = _a.isFullWidth;
    return (React.createElement(AonPopover, { isFullWidth: isFullWidth, position: position, tooltipContent: React.createElement(AonLabel, { type: LABEL_TYPE.BODY, darkMode: !darkMode }, text), popoverWidth: width, triggerElement: children, eventType: "hover" }));
};
export { AonTooltip };
